import React from 'react';
import {Card, CardText, CardBody, CardTitle, CardSubtitle} from 'reactstrap';
import PropTypes from 'prop-types';
import livestream from '../images/icons/livestream.svg';
import '../scss/_openHouse.scss';
import { formatOpenHouseTime, formatDateWithYearInStandardUSFormat } from './utils';

class OpenHouse extends React.Component {
    static contextTypes = {
        router: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props);
        this.state = {
            openHouses: props.OpenHouses,
            importantNote: props.OpenHouses.ImportantNote
        }
    }

    render() {
        return (<div>
            <Card className='open_house_card'>
                <CardBody>
                    <CardTitle className='open_house_card_title'>
                            Open houses scheduled:
                    </CardTitle>
                    {this.state.importantNote ?
                        <CardSubtitle className='open_house_card_sub_title mg-btm-16'>
                            <span className='open_house_important_note'>Attention! </span>
                            <span dangerouslySetInnerHTML={{ __html: this.state.importantNote.replace('*livestreamicon*', '<img src="' + livestream + '" />') }} />
                        </CardSubtitle> : null
                    }
                    {this.state.openHouses.Times.map((openHouseTime, i) => {
                        return (
                            <CardText className='open_house_card_text' key={i}>
                                <span>
                                    {openHouseTime.LiveStreamUrl &&
                                        <a href={openHouseTime.LiveStreamUrl} target="_blank" rel="noopener noreferrer">
                                            {formatDateWithYearInStandardUSFormat(openHouseTime.Start) + ', ' + formatOpenHouseTime(openHouseTime.From) + '-' + formatOpenHouseTime(openHouseTime.To)}
                                        </a>
                                    }
                                    {!openHouseTime.LiveStreamUrl &&
                                        formatDateWithYearInStandardUSFormat(openHouseTime.Start) + ', ' + formatOpenHouseTime(openHouseTime.From) + '-' + formatOpenHouseTime(openHouseTime.To)
                                    }
                                </span>
                                <span>
                                    {openHouseTime.LiveStreamUrl &&
                                        <a href={openHouseTime.LiveStreamUrl} target="_blank" rel="noopener noreferrer">
                                            <img src={livestream} className="mg-lft-8" alt="Live Stream Link" />
                                        </a>
                                    }
                                </span>
                            </CardText>
                        )
                    })}
                    
                </CardBody>
            </Card>
        </div>)
    }
}

export default OpenHouse;